import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { KeyRound, UserCircle } from "lucide-react";
import { Card } from "@/design-system/components/ui";
import { PageHeader } from "@/components/layout/PageHeader";

/**
 * Phoenix Capital account hub. Landing page at /account that links to the
 * personal surfaces a signed-in user manages for themselves — their profile
 * and their sign-in credentials.
 */
interface AccountCard {
  key: string;
  title: string;
  description: string;
  route: string;
  icon: LucideIcon;
}

const CARDS: AccountCard[] = [
  {
    key: "profile",
    title: "My Profile",
    description: "View and edit your biography, photo, and contact details.",
    route: "/account/profile",
    icon: UserCircle,
  },
  {
    key: "password",
    title: "Change Password",
    description: "Update the password for your Phoenix Capital sign-in.",
    route: "/account/password",
    icon: KeyRound,
  },
];

export function AccountManagementPage() {
  return (
    <>
      <PageHeader
        eyebrow="Account"
        title="Account"
        description="Manage your profile and sign-in credentials."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-space-3">
        {CARDS.map((c) => (
          <Link
            key={c.key}
            to={c.route}
            aria-label={`Open ${c.title}`}
            className="group"
          >
            <Card className="p-space-4 h-full flex flex-col gap-space-2 border border-border-light hover:border-gold hover:shadow-sm transition-colors">
              <div className="flex items-center gap-space-2 text-gold-shadow group-hover:text-gold">
                <c.icon size={20} strokeWidth={1.5} aria-hidden />
                <h3 className="font-display font-bold text-h4 text-onyx m-0">{c.title}</h3>
              </div>
              <p className="text-small text-gray-dark leading-normal">{c.description}</p>
            </Card>
          </Link>
        ))}
      </div>
    </>
  );
}
